import { render, staticRenderFns } from "./BlockInfos.vue?vue&type=template&id=16d94bdd&scoped=true&"
import script from "./BlockInfos.vue?vue&type=script&lang=js&"
export * from "./BlockInfos.vue?vue&type=script&lang=js&"
import style0 from "./BlockInfos.vue?vue&type=style&index=0&id=16d94bdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d94bdd",
  null
  
)

export default component.exports